<template>
  <div>
    <component v-bind:is="headerComponent"></component>
    <div class="content search-content">
      <div class="container">
          <h1 class="mb1">{{ $t('searchResultsTitle') }}</h1>
          <p class="i">
            {{ this.results.length }} {{ $t('resultsCountText') }} {{
              this.searchString
            }}
          </p>
          <div>
            <h3>{{ $t('knowledgeBaseText') }}</h3>
            <ul class="mb2 list pa0">
              <li class="search-result pv3" v-for="(result, i) in results" :key="i">
                <router-link
                    class="light-blue no-underline fw4"
                    :to="{ name: 'article', hash: getHashLink(result) }"
                    v-html="result.title"
                ></router-link>
                <ul class="pa0 list">
                  <li class="di">
                    <router-link
                        class="light-blue no-underline pr3 f5 fw3"
                        :to="{ name: getCategoryRouterLink(result.categoryId) }"
                    >{{ result.category }}</router-link>
                  </li>
                  <li class="di">
                    <router-link
                        class="light-blue no-underline pr3 f5 fw3"
                        :to="{ name: 'article', hash: getHashLink(result) }"
                    >{{ result.title }}</router-link>
                  </li>
                  <li class="light-blue pr3 f5 fw3 di">{{ $t('supportAdminText') }}</li>
                </ul>
                <div class="mt3 result-body" v-html="result.snippet"></div>
              </li>
            </ul>
          </div>
      </div>

    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import {
  searchZendeskAPITemp,
  getCategoryIdByArticleId,
  getCategoryPageName,
  getComponent,
  getPageHash
} from '@/utils/common';

export default {
  data: () => {
    return {
      results: [],
      loading: false,
      searchString: ''
    };
  },
  created() {
    this.searchArticles();
  },

  name: 'search',
  computed: {
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    },

    query() {
      // TODO: Make this reusable
      const matches = this.$route.hash.match(new RegExp('query' + '=([^&]*)'));
      return matches ? decodeURIComponent(matches[1]) : '';
    }
  },
  methods: {
    getHashLink(article) {
      return getPageHash(article);
    },
    getCategoryById(articleId) {
      let categoryId = getCategoryIdByArticleId(articleId);
      return this.$store.state.categories[categoryId];
    },
    getCategoryRouterLink(categoryId) {
      return getCategoryPageName(categoryId, this.$store.state.flowObject.pages);
    },
    async searchArticles() {
      const articles = await searchZendeskAPITemp(this.query);
      for (const article of articles) {
        article.snippet = article.snippet.replace(/strong>/g, 'i>');
      }
      this.results = articles;
      this.searchString = this.query ? `"${this.query.split('+').join(' ')}"` : `"${this.query}"`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';

.search-content {
  color: #333;
  font-family: "Segoe UI", Arial, sans-serif;
  h1 {
    font-weight: 300;
    font-size: 40px;
    color: #333;
    font-family: "Segoe UI", Arial, sans-serif;
  }
}

.search-results {
  max-width: 70em;
}
.search-result:first-child {
  border-top: 1px solid #ddd;
}
.search-result {
  border-bottom: 1px solid #ddd;
}
.light-blue {
  color: #287EFF;
}

</style>
